export const LEAGUES_ACTIVE_TEAMS_FAILURE = 'LEAGUES:ACTIVE_TEAMS_FAILURE';
export const LEAGUES_ACTIVE_TEAMS_REQUEST = 'LEAGUES:ACTIVE_TEAMS_REQUEST';
export const LEAGUES_ACTIVE_TEAMS_SUCCESS = 'LEAGUES:ACTIVE_TEAMS_SUCCESS';
export const LEAGUES_DASHBOARD_TEAMS_FAILURE = 'LEAGUES:DASHBOARD_TEAMS_FAILURE';
export const LEAGUES_DASHBOARD_TEAMS_REQUEST = 'LEAGUES:DASHBOARD_TEAMS_REQUEST';
export const LEAGUES_DASHBOARD_TEAMS_SUCCESS = 'LEAGUES:DASHBOARD_TEAMS_SUCCESS';
